import React, { useState } from "react";
import { Link } from "react-router-dom";

import { fetchAuditEntityHistory } from "../services/auditService";

function copyText(text) {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(() => {});
    return;
  }
  const ta = document.createElement("textarea");
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  document.body.removeChild(ta);
}

/**
 * Expandable row actions: copy share_transaction id, fetch audit trail, link to full audit UI.
 */
export default function ReconTxnInvestigate({ txn }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [auditRows, setAuditRows] = useState([]);
  const [err, setErr] = useState("");
  const [copied, setCopied] = useState(false);

  const refId = txn?.reference_id || "";

  const loadAudit = async () => {
    if (!refId) return;
    setLoading(true);
    setErr("");
    try {
      const { data } = await fetchAuditEntityHistory("share_transaction", refId);
      setAuditRows(Array.isArray(data) ? data : []);
      setOpen(true);
    } catch (e) {
      setErr(e.response?.data?.detail || "Could not load audit history.");
      setAuditRows([]);
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const onCopy = () => {
    copyText(refId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="recon-investigate">
      <div className="recon-investigate__actions">
        <button type="button" className="history-btn history-btn--ghost recon-investigate__btn" onClick={onCopy}>
          {copied ? "Copied" : "Copy ID"}
        </button>
        <button
          type="button"
          className="history-btn history-btn--ghost recon-investigate__btn"
          onClick={loadAudit}
          disabled={loading || !refId}
        >
          {loading ? "…" : open ? "Refresh trail" : "Investigate"}
        </button>
        <Link
          to={`/admin/audit?entity_type=share_transaction&entity_id=${encodeURIComponent(refId)}`}
          className="history-btn history-btn--ghost recon-investigate__btn recon-investigate__link"
        >
          Full audit log
        </Link>
      </div>
      {open ? (
        <div className="recon-investigate__panel">
          <div className="recon-investigate__ref muted small">
            Reference: <code>{refId}</code>
          </div>
          {err ? <p className="form-error small">{err}</p> : null}
          {!err && auditRows.length === 0 ? (
            <p className="muted small">No platform audit entries linked to this transaction yet.</p>
          ) : null}
          {auditRows.length > 0 ? (
            <ul className="recon-investigate__list">
              {auditRows.slice(0, 8).map((row) => (
                <li key={row.id}>
                  <span className="recon-investigate__when">
                    {row.created_at ? new Date(row.created_at).toLocaleString() : "—"}
                  </span>
                  <strong>{row.action_type}</strong>
                  <span className="muted small"> · {row.status}</span>
                  {row.description ? <div className="muted small">{row.description}</div> : null}
                </li>
              ))}
            </ul>
          ) : null}
          {auditRows.length > 8 ? (
            <p className="muted small">Showing 8 of {auditRows.length}. Use “Full audit log” for complete history.</p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
